export default "__VITE_ASSET__BPxC3Yc5__"